import { PersonalLoan } from "typedef/PersonalLoan";

const getRedirectMessagePersonalLoan = ({ loan }: { loan?: PersonalLoan }) => {
  const goToDeals = !loan?.borrowerSteps?.dealset?.selectedDeal;
  const documents = loan?.borrowerSteps?.documents || [];
  const documentsNeeded =
    documents.length > 0
      ? documents?.some((doc) => doc.documentStatus === "needed")
      : false;
  const goToLoanPurpose =
    !loan?.borrowerSteps?.loanPurpose &&
    loan?.borrowerSteps?.dealset?.selectedDeal &&
    !documentsNeeded;

  if (goToDeals) {
    return "Go to Deals";
  } else if (goToLoanPurpose) {
    return "Go to Loan Purpose";
  } else if (documentsNeeded) {
    return "Go to Upload Documents";
  } else if (loan?.archivedAt) {
    return "Go Home Monitor";
  } else {
    return "Go To Tracker";
  }
};

export default getRedirectMessagePersonalLoan;
